import { projectIcons } from "../tokens/icon-tokens";

export interface DropdownOption {
    label: string;
    value: string;
}

export class CommonHelper {
    static sortStringOptions(options: string[], pinFirst?: string): string[] {
        const sorted = [...options].sort((a, b) =>
            a.localeCompare(b, undefined, { sensitivity: "base" })
        );

        if (pinFirst !== undefined && sorted.includes(pinFirst)) {
            return [pinFirst, ...sorted.filter((o) => o !== pinFirst)];
        }

        return sorted;
    }

    static sortRecordByKey<V>(
        record: Record<string, V>,
        pinFirst?: string
    ): Record<string, V> {
        const keys = this.sortStringOptions(Object.keys(record), pinFirst);
        const result: Record<string, V> = {};
        for (const key of keys) {
            result[key] = record[key];
        }

        return result;
    }

    static getFlattenedIcons(withNone: boolean = true) {
        const flatIcons = Object.values(projectIcons).reduce<Record<string, any>>((acc, category) => {
            return { ...acc, ...category };
        }, {});

        const sorted = this.sortRecordByKey(flatIcons);

        return withNone
            ? { None: null, ...sorted }
            : sorted;
    }

    static getSortedIconNames(): string[] {
        return Object.keys(this.getFlattenedIcons(false));
    }
}
